module.exports = __webpack_public_path__ + "img/next-step.2b2f184d.svg";